import React from 'react';
import '../app.css';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import images from "./images";

export default () => {
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className='sidebar'>
            <div className="description">
                <span className='description-label'><u>Monitoring Stack</u></span>
            </div>
            <Tippy className="tooltip" content={<span>Drag Prometheus node to the canvas on the right</span>}>
                <div className="dndnode" onDragStart={(event) => onDragStart(event, 'prometheus')} draggable>
                    Promethues
                    <img
                        src={images.Prometheus}
                        height="20px"
                        style={{ margin: 5 }}
                    />
                </div>
            </Tippy>
            <Tippy className="tooltip" content={<span>Drag Thanos node to the canvas on the right</span>}>
                <div className="dndnode" onDragStart={(event) => onDragStart(event, 'thanos')} draggable>
                    Thanos
                    <img
                        src={images.Thanos}
                        height="20px"
                        style={{ margin: 5 }}
                    />
                </div>
            </Tippy>
            <Tippy className="tooltip" content={<span>Drag Cortex node to the canvas on the right</span>}>
                <div className="dndnode" onDragStart={(event) => onDragStart(event, 'output')} draggable
                    style={{
                        pointerEvents: "none",
                        opacity: 0.4
                    }}>
                    Cortex
                </div>
            </Tippy>

        </div>
    );
};
